(() => {
  'use strict';
  document.documentElement.classList.replace('no-js', 'js');
  let drawer = null;
  let returnFocus = null;
  const overlay = document.querySelector('[data-ct-overlay]');
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('ct-is-open');
    if (drawer.classList.contains('ct-mobile-menu')) drawer.hidden = true;
    drawer.removeAttribute('role');
    drawer.removeAttribute('aria-modal');
    document.body.classList.remove('ct-locked');
    if (overlay) overlay.hidden = true;
    document.querySelectorAll('[data-ct-open][aria-expanded="true"]').forEach(el => el.setAttribute('aria-expanded', 'false'));
    const previous = returnFocus;
    drawer = null;
    returnFocus = null;
    if (previous && previous.isConnected) previous.focus({ preventScroll: true });
  };
  const activateTab = (tab, focus) => {
    const tabs = tab.closest('[data-ct-tabs]');
    if (!tabs) return;
    tabs.querySelectorAll('[data-ct-tab]').forEach(button => {
      const active = button === tab;
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
    });
    tabs.querySelectorAll('[data-ct-panel]').forEach(panel => { panel.hidden = panel.dataset.ctPanel !== tab.dataset.ctTab; });
    if (focus) tab.focus();
  };
  const initTabs = root => root.querySelectorAll('[data-ct-tabs]').forEach(tabs => {
    const active = tabs.querySelector('[aria-selected="true"]') || tabs.querySelector('[data-ct-tab]');
    if (active) activateTab(active, false);
  });
  window.CTTheme = {
    strings: JSON.parse(document.getElementById('ct-strings')?.textContent || '{}'),
    routes: JSON.parse(document.getElementById('ct-routes')?.textContent || '{}'),
    init: initTabs
  };
  initTabs(document);
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-ct-open]');
    if (opener) {
      const target = document.getElementById(opener.dataset.ctOpen);
      if (!target) return;
      closeDrawer();
      drawer = target;
      returnFocus = opener;
      drawer.hidden = false;
      drawer.classList.add('ct-is-open');
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      opener.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ct-locked');
      if (overlay) overlay.hidden = false;
      drawer.querySelector('button, a, input, summary')?.focus();
      return;
    }
    if (event.target.closest('[data-ct-close]')) closeDrawer();
    const tab = event.target.closest('[data-ct-tab]');
    if (tab) activateTab(tab, false);
    const quantityButton = event.target.closest('[data-ct-quantity]');
    if (quantityButton) {
      const input = quantityButton.closest('.ct-quantity')?.querySelector('input');
      if (!input || input.disabled) return;
      const step = Number(input.step) || 1;
      const min = Number(input.min) || 0;
      const max = input.max ? Number(input.max) : Infinity;
      const value = Number(input.value) || min;
      input.value = String(Math.max(min, Math.min(max, value + Number(quantityButton.dataset.ctQuantity) * step)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    document.querySelectorAll('.ct-mega[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-ct-autosubmit]')) event.target.form?.requestSubmit();
    if (event.target.matches('[data-ct-personalize-choice]')) {
      const widget = event.target.closest('[data-ct-personalize-root]');
      const yes = widget?.querySelector('[data-ct-personalize-choice][value="yes"]')?.checked;
      const fields = widget?.querySelector('.ct-personalize__fields');
      if (!fields) return;
      fields.hidden = !yes;
      widget.classList.toggle('neb-personalize--active', !!yes);
      fields.querySelectorAll('[data-ct-personal-field]').forEach(input => {
        input.disabled = !yes;
        input.required = !!yes;
        input.setCustomValidity('');
      });
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeDrawer();
      document.querySelectorAll('.ct-mega[open]').forEach(details => { details.open = false; details.querySelector('summary')?.focus(); });
    }
    if (drawer && event.key === 'Tab') {
      const focusable = [...drawer.querySelectorAll('a[href], button:not(:disabled), input:not(:disabled), select, summary, [tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
    const tab = event.target.closest('[data-ct-tab]');
    if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      const buttons = [...tab.closest('[data-ct-tabs]').querySelectorAll('[data-ct-tab]')];
      const index = buttons.indexOf(tab);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
      activateTab(buttons[next], true);
    }
  });
  document.addEventListener('shopify:section:load', event => { initTabs(event.target); });
  matchMedia('(min-width: 1100px)').addEventListener('change', closeDrawer);
  document.querySelectorAll('.ct-mega').forEach(details => details.addEventListener('toggle', () => {
    if (details.open) document.querySelectorAll('.ct-mega[open]').forEach(other => { if (other !== details) other.open = false; });
  }));
  if ('customElements' in window && !customElements.get('ct-recommendations')) {
    customElements.define('ct-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded || !this.dataset.url || this.querySelector('.ct-card')) return;
        const load = async () => {
          if (this.dataset.loaded) return;
          this.dataset.loaded = 'true';
          try {
            const response = await fetch(this.dataset.url);
            if (!response.ok) return;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const content = html.querySelector('ct-recommendations');
            if (content) this.innerHTML = content.innerHTML;
          } catch {}
        };
        if (!('IntersectionObserver' in window)) { load(); return; }
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
        }, { rootMargin: '250px' });
        observer.observe(this);
        this._observer = observer;
      }
      disconnectedCallback() { this._observer?.disconnect(); }
    });
  }
})();
